// Ecosystem Edge 04 — archetype→surface hook. Thin, read-only wrapper
// over useBettingProfile that resolves the ArchetypeSurface for the
// current user (archetype + profile_confidence → surface config).
// Zero behavioural change until a surface consumes it (the dashboard
// re-layout is a separate design-gated step). Honest: while the
// profile is loading or no archetype is detected it returns
// DEFAULT_SURFACE — never guesses an archetype.

import { useMemo } from "react";
import { useBettingProfile } from "./useBettingProfile.ts";
import {
  surfaceForArchetype,
  DEFAULT_SURFACE,
  type ArchetypeSurface,
} from "../onboarding/archetypeSurface.ts";

export interface UseArchetypeSurfaceState {
  surface: ArchetypeSurface;
  loading: boolean;
  /** True once a real archetype drove the surface (not the default). */
  resolved: boolean;
}

export function useArchetypeSurface(): UseArchetypeSurfaceState {
  const { profile, loading } = useBettingProfile();
  const surface = useMemo(
    () =>
      loading
        ? DEFAULT_SURFACE
        : surfaceForArchetype(profile.archetype, profile.profile_confidence),
    [loading, profile.archetype, profile.profile_confidence],
  );
  return {
    surface,
    loading,
    resolved: !loading && profile.archetype !== null,
  };
}
